:host {
  --cms-flex-width: 0 1 100%;
  width: 100%;
  @include cms-components-host-defaults;
}

.host-inner {
  max-width: calc(var(--cms-container-max-width) - var(--cms-spacing-200));
  margin: 0 auto;
  display: flex;
  gap: var(--cms-spacing-100);
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 1rem;
  list-style: none;
}

.error-massage {
  color: var(--cms-semanticColors-error-text);
}

.service-teaser {
  padding: var(--cms-spacing-100) var(--cms-spacing-200);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
  flex: var(--cms-flex-width);
}

.service-teaser:not(.error-massage) {
  background-color: var(--cms-theme-background-color-teaser);
}


.icon-image {
  max-width: 100%;
  height: 100%;
  object-fit: contain;
  width: 5.25rem;
}

.teaser-link {
  color: var(--cms-theme-inverted-text-color);
  display: flex;
  gap: var(--cms-spacing-100);
  align-items: center;
  text-decoration: none;
  font-family: var(--cms-brandfont2);
  font-size: var(--cms-font-size-112);
  line-height: var(--cms-line-height-133);
  height: 100%;
}

.service-icon-wrapper,
.text-wrapper,
.icon-wrapper {
  align-self: center;
  flex: 0 1 calc((100% / 3));
}

.service-icon-wrapper {
  height: 100%;
}

.icon-wrapper {
  text-align: right;

}

@include media-width($breakpoint-sm) {
  .service-teaser {
    --cms-flex-width: 0 1 calc(100% /3);
  }
}